import React, { useEffect, useState } from 'react'
import styles from './cookies.module.css'

const Cookies = () => {
    const [accepted, setAccepted] = useState(false);

    useEffect(() => {
        const isAccepted = localStorage.getItem('cookiesAccepted');
        if (isAccepted) {
          setAccepted(true);
        }
      }, []);
    
      const handleAccept = () => {
        localStorage.setItem('cookiesAccepted', 'true');
        setAccepted(true);
      };
    
      if (accepted) return null;
    
    return (
        <div className={styles.container}>
            <div className={styles.textStyle}>
                We use cookies to improve your experience on our website by browsing this website, you agree to use cookies
            </div>
            <div className={styles.buttonStyle} onClick={handleAccept}>
                Accept
            </div>
        </div>
    )
}

export default Cookies